// src/components/AltaWizard/StepConductores.jsx
import React, { useMemo } from "react";

function slugifyLocal(s) {
  return (s || "")
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .toUpperCase();
}

export default function StepConductores({ titular, rol, conductores, onChange }) {
  const set = (next) => onChange(next);
  const list = Array.isArray(conductores) ? conductores : [];

  const titularConduce = (rol || "FACTURA_Y_CONDUCE") !== "SOLO_FACTURA";
  const titularSlug = useMemo(
    () => slugifyLocal(titular?.nombre || titular?.dni || "TITULAR"),
    [titular]
  );

  const add = () =>
    set([...list, { nombre: "", dni: "", email: "", telefono: "", permisoCad: "", capCad: "" }]);

  const remove = (idx) => set(list.filter((_, i) => i !== idx));

  const update = (idx, patch) =>
    set(list.map((c, i) => (i === idx ? { ...c, ...patch } : c)));

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Conductores</h2>

      {titularConduce ? (
        <div className="text-xs text-gray-600">
          El titular también conducirá. Se creará su carpeta:<br/>
          <code>CONDUCTORES/{titularSlug}/DATOS_PERSONALES</code> y <code>CONDUCTORES/{titularSlug}/NOMINAS</code>
        </div>
      ) : (
        <div className="text-xs text-gray-600">
          El titular no conducirá. Añade al menos un conductor.
        </div>
      )}

      <div className="mt-2 space-y-3">
        {list.map((c, idx) => {
          const s = slugifyLocal(c?.nombre || c?.dni || `CONDUCTOR_${idx + 1}`);
          return (
            <div key={idx} className="p-3 rounded-lg border">
              <div className="text-xs text-gray-500 mb-2">
                Carpetas previstas:{" "}
                <code>CONDUCTORES/{s}/DATOS_PERSONALES</code> y <code>CONDUCTORES/{s}/NOMINAS</code>
              </div>

              <div className="grid md:grid-cols-2 gap-3">
                <div>
                  <label className="text-sm">Nombre</label>
                  <input
                    className="w-full border rounded px-2 py-1"
                    value={c.nombre || ""}
                    onChange={(e) => update(idx, { nombre: e.target.value })}
                  />
                </div>
                <div>
                  <label className="text-sm">DNI/NIE</label>
                  <input
                    className="w-full border rounded px-2 py-1"
                    value={c.dni || ""}
                    onChange={(e) => update(idx, { dni: e.target.value })}
                  />
                </div>
                <div>
                  <label className="text-sm">Email</label>
                  <input
                    className="w-full border rounded px-2 py-1"
                    value={c.email || ""}
                    onChange={(e) => update(idx, { email: e.target.value })}
                  />
                </div>
                <div>
                  <label className="text-sm">Teléfono</label>
                  <input
                    className="w-full border rounded px-2 py-1"
                    value={c.telefono || ""}
                    onChange={(e) => update(idx, { telefono: e.target.value })}
                  />
                </div>
                <div>
                  <label className="text-sm">Caducidad permiso conducir</label>
                  <input
                    type="date"
                    className="w-full border rounded px-2 py-1"
                    value={c.permisoCad || ""}
                    onChange={(e) => update(idx, { permisoCad: e.target.value })}
                  />
                </div>
                <div>
                  <label className="text-sm">Caducidad CAP (si aplica)</label>
                  <input
                    type="date"
                    className="w-full border rounded px-2 py-1"
                    value={c.capCad || ""}
                    onChange={(e) => update(idx, { capCad: e.target.value })}
                  />
                </div>
              </div>

              <div className="flex justify-end mt-3">
                <button
                  className="text-sm px-3 py-1 rounded border hover:bg-gray-50"
                  onClick={() => remove(idx)}
                >
                  Eliminar
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <button
        className="px-3 py-2 rounded bg-indigo-600 text-white hover:bg-indigo-700"
        onClick={add}
      >
        + Añadir conductor
      </button>
    </div>
  );
}
